"use client";
import { errorToast, successToast } from "@ft/common/components/CustomToast/SuccessToast";
import { CustomNumberInput } from "@ft/common/components/UiComponent/CustomInput";
import { useEffect, useState } from "react";
import { InputOutputViewer } from "../../helper/InputOutputViewer/InputOutputViewer";
import {
  GeneratorRandomPasswordInput,
  GeneratorRandomPasswordOptions,
} from "./GeneratorRandomPasswordOptions";
import PasswordStrengthIndicator from "./PasswordStrengthIndicator";

const minRage = 4;
const maxRange = 100;
function GeneratorRandomPassword() {
  const [result, setResult] = useState("");

  const [input, setInput] = useState<GeneratorRandomPasswordInput>({
    uppercase: true,
    lowercase: true,
    special: true,
    numbers: true,
    capitalizeFirst: false,
    range: 8,
  });

  function onInputChange(event: React.ChangeEvent<HTMLInputElement>) {
    setInput((prev) => ({
      ...prev,
      range: Number(event.target.value),
    }));
  }






  function generatePassword() {
    function capitalizeFirstLetter(str: string) {
      return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    }
    const upperCase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    const lowerCase = "abcdefghijklmnopqrstuvwxyz";
    const numbers = "0123456789";
    const specialChars = "!@#$%^&*()_+[]{}|;:,.<>?";

    let allChars = "";
    try {
      if (input.uppercase) allChars += upperCase;
      if (input.lowercase) allChars += lowerCase;
      if (input.numbers) allChars += numbers;
      if (input.special) allChars += specialChars;

      function getRandomChar(chars: string): string {
        return chars[Math.floor(Math.random() * chars.length)];
      }

      let password: string[] = [];
      if (input.uppercase) password.push(getRandomChar(upperCase));
      if (input.lowercase) password.push(getRandomChar(lowerCase));
      if (input.numbers) password.push(getRandomChar(numbers));
      if (input.special) password.push(getRandomChar(specialChars));



      for (let i = password.length; i < input.range; i++) {
        password.push(getRandomChar(allChars));
      }

      password = password.sort(() => Math.random() - 0.5);
      let passwordString
      if (input.capitalizeFirst) {
        passwordString = capitalizeFirstLetter(password.join(""))
      } else {
        passwordString = password.join("")
      }
      setResult(passwordString);
    } catch (err) {
      errorToast("Failed to generate password. Please try again.")
    }
  }



  useEffect(() => {
    generatePassword();
  }, []);

  return (

    <InputOutputViewer
      byte={result}
      input={{
        showInput: true,
        buttonName: "Generate Secure Password",
        options: (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              marginTop: "50%",
            }}
          >
            <CustomNumberInput
              min={minRage}
              max={maxRange}
              onChange={(value: number) =>
                setInput((prev) => ({
                  ...prev,
                  range: value,
                }))
              }
              value={input.range}
            ></CustomNumberInput>
            <input
              style={{ marginTop: "20px", width: "100%" }}
              type="range"
              min={minRage}
              max={maxRange}
              value={input.range}
              onChange={onInputChange}
            ></input>
            <PasswordStrengthIndicator password={result} />
            <GeneratorRandomPasswordOptions input={input} setInput={setInput} />
          </div>
        ),
      }}
      options={{ hideInput: true, buttonAfterOption: true }}
      onClick={() => {
        if (input.lowercase || input.numbers || input.special || input.uppercase) {
          generatePassword()
          successToast("New password generated! Keep it safe.")
        } else {
          errorToast("Please select at least one character type (uppercase, lowercase, numbers, special characters).")
        }
      }}
    />


  );
}

export default GeneratorRandomPassword;
